import { render, staticRenderFns } from "./PoleRf.vue?vue&type=template&id=8141779c&scoped=true&"
import script from "./PoleRf.vue?vue&type=script&lang=js&"
export * from "./PoleRf.vue?vue&type=script&lang=js&"
import style0 from "./PoleRf.vue?vue&type=style&index=0&id=8141779c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8141779c",
  null
  
)

export default component.exports